import CoreExtension from '@/core/CoreExtension'

export default CoreExtension.extend({
	props: ['limit'],
	data() {
		return {
            useLimit: true
		}
	},
    components: {
        "pmh-history": () => import("./History"),
        "pmh-diagnostic-categories": () => import("./DiagnosticCategories"),
        "pmh-blood-type": () => import("./BloodType"),
        "pmh-disabilities": () => import("./Disabilities"),
        "pmh-chronic-prescriptions": () => import("./ChronicPrescriptions"),
        "pmh-episodes": () => import("./Episodes"),
        "pmh-decursus": () => import("./Decursus"),
        "pmh-referrals": () => import("./Referrals"),
        "pmh-allergies": () => import("./Allergies"),
        "pmh-prescriptions": () => import("./Prescriptions"),
        "pmh-vital-functions": () => import("./VitalFunctions"),
        "pmh-measurements": () => import("./Measurements"),
        "pmh-medicalcards": () => import("./MedicalCards"),
        "pmh-diagnostic-referrals": () => import("./DiagnosticReferrals"),
        "pmh-vaccinations": () => import("./Vaccinations"),
        "pmh-procedures": () => import("./Procedures"),
        "pmh-attests": () => import("./Attests"),
    },
    computed: {
        plugins() {
            return [
                { permission_key: 'history', key: 'history', icon: 'fa-files-medical', title: 'General History'},
                { permission_key: 'patient', key: 'diagnostic-categories', icon: 'fa-comment-medical', title: 'Diagnostic Categories'},
                { permission_key: 'bloodtype', key: 'blood-type', icon: 'fa-droplet', title: 'Blood Type'},
                { permission_key: 'disabilities', key: 'disabilities', icon: 'fa-circle-exclamation', title: 'Disabilities'},
                { permission_key: 'prescription', key: 'chronic-prescriptions', icon: 'fa-prescription-bottle-medical', title: 'Chronic Prescriptions'},
                { permission_key: 'episodes', key: 'episodes', icon: 'fa-heart-pulse', title: 'Episodes'},
                { permission_key: 'decursus', key: 'decursus', icon: 'fa-notes-medical', title: 'Decursus'},
                { permission_key: 'referral', key: 'referrals', icon: 'fa-forward', title: 'Referrals'},
                { permission_key: 'allergies', key: 'allergies', icon: 'fa-hand-dots', title: 'Allergies'},
                { permission_key: 'prescription', key: 'prescriptions', icon: 'fa-prescription-bottle-pill', title: 'Prescriptions'},
                { permission_key: 'measurements', key: 'measurements', icon: 'fa-weight-scale', title: 'Measurements'},
                { permission_key: 'vitals', key: 'vital-functions', icon: 'fa-stethoscope', title: 'Vital Functions'},
                { permission_key: 'medicalcard', key: 'medicalcards', icon: 'fa-folder-medical', title: 'Medical Cards'},
                { permission_key: 'lab', key: 'diagnostic-referrals', icon: 'fa-flask-round-potion', title: 'Diagnostic Referrals'},
                { permission_key: 'vaccination', key: 'vaccinations', icon: 'fa-syringe', title: 'Vaccinations'},
                { permission_key: 'procedure', key: 'procedures', icon: 'fa-scalpel', title: 'Procedures'},
                { permission_key: 'attest', key: 'attests', icon: 'fa-calendar-range', title: 'Attests'},
            ]
        }
    }
})